import type { AppRoute } from "@/lib/routing";
import { KnowledgePage } from "./KnowledgePage";

export const routes: AppRoute[] = [
  {
    path: "/knowledge",
    element: <KnowledgePage />,
    handle: {
      title: "Knowledge",
      keywords: ["odor vocabulary", "families", "descriptors", "usage ranges", "coverage", "organ", "reference lists"],
    },
  },
];
